import { Navigate } from 'react-router';
import { Loading } from '@/components/ui/Loading';
import { useI18n } from '@/i18n/context';
import { useAppState } from './useAppState';

export function StartRedirect() {
  const { ready, activeLearner, learners } = useAppState();
  const { t } = useI18n();
  if (!ready) return <Loading label={t('app.loading')} />;
  if (activeLearner) return <Navigate to="/learn" replace />;
  return <Navigate to={learners.length > 0 ? '/profiles' : '/welcome'} replace />;
}
